<template>
  <modal
    name="add-inspection-modal"
    class="full-height-top-right"
    height="auto"
    width="760px"
    :adaptive="true"
    :scrollable="true"
    :click-to-close="false"
    @opened="isModalOn"
    @closed="isModalOffLocal"
  >
    <div class="modal custom-modal is-active">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span v-if="inspection">
              {{ inspection.status === 'Draft' ? 'Add' : 'Update' }}
            </span> certification
            <help-icon
              v-if="isResidential"
              modal="rental-instructions"
            />
            <help-icon
              v-else
              modal="daycare-instructions"
            />
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="$modal.hide('add-inspection-modal');"
          />
        </header>
        <section class="modal-card-body p-none">
          <!-- <h3 class=" m-b-md">
            <span v-html="$wording.spf($wording.certify.text_3, titlePropertyTypeAndUnits)" />
          </h3> -->
          <!-- <p
            v-if="!error"
            class="m-b-md"
          >
            Number of units submitted:
            <span
              class="tag is-success is-vertical-align-middle has-text-weight-bold"
              v-text="passedPendingInspections.length"
            />
            /
            Number of units left:
            <span
              class="tag is-warning is-vertical-align-middle has-text-weight-bold"
              v-text="leftToSubmit"
            />
          </p> -->
          <div
            v-if="error === true"
            class="p-lg"
          >
            <div class="notification is-light is-warning m-t-md">
              <p>
                <span v-html="$wording.certify.text_9" />
                &nbsp;
                <router-link
                  class="has-text-weight-bold"
                  :to="{ name: 'submissions-details', params: { uuid: $route.params.uuid }}"
                  v-text="'Go back'"
                />
              </p>
            </div>
          </div>
          <div
            v-else-if="!inspection"
            class="p-lg"
          >
            <p>Loading...</p>
          </div>
          <template v-if="Object.keys(details).length > 0 && error === false">
            <fix-inspection-notice
              v-if="inspection"
              v-show="fixingInspections && !isAdmin"
              class="p-lg m-b-none"
              :unit-name="inspection.name"
              :street-address="streetAddress"
            />
            <!-- UNIT! -->
            <unit
              v-if="inspection"
              ref="inspection"
              v-model="inspection"
              :is-name-editable="isNameEditable"
              :details="details"
            />
            <div class="p-lg">
              <div
                v-if="leftToSubmit && !isAdmin"
                class="field"
              >
                <div class="control">
                  <checkbox
                    v-model="assertion"
                    :rules="checkboxRules"
                    placeholder="Assertion"
                    name="Assertion"
                    :value="true"
                  >
                    <!-- TODO: I will need to replace this pdf in the future. -->
                    <span v-html="$wording.spf($wording.certify.attestation_1, 'https://www.phila.gov/services/permits-violations-licenses/apply-for-a-permit/environmental-permits-and-approvals/submit-lead-certification-and-inspection-reports/')" />
                  </checkbox>
                </div>
              </div>

              <div
                v-show="issues"
                class="notification is-warning"
              >
                <p v-text="issues" />
              </div>

              <div
                v-if="leftToSubmit && $route.name !== 'update-inspections-one'"
                class="field is-grouped is-grouped-centered m-t-lg"
              >
                <div class="control">
                  <button
                    class="is-text button"
                    @click.prevent.stop="cancel"
                  >
                    Cancel
                  </button>
                </div>
                <div
                  ref="save-draft-tooltip"
                  :data-tippy-content="$wording.certify.save_draft_disabled"
                  :disabled="!assertion || loading"
                  class="control"
                >
                  <button
                    :disabled="assertion || loading"
                    :class="{ 'is-loading': loading }"
                    class="button is-secondary save-draft"
                    @click="submit(false)"
                  >
                    Save as draft
                  </button>
                </div>
                <div
                  ref="finish-and-certify-tooltip"
                  class="control"
                  :disabled="assertion || isAdmin"
                  :data-tippy-content="$wording.certify.finish_and_certify_disabled"
                >
                  <button
                    :disabled="(!isAdmin && !assertion) || loading"
                    :class="{ 'is-loading': loading }"
                    class="button is-primary finish-and-certify"
                    @click="submit(true)"
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div
                v-else-if="$route.name === 'update-inspections-one'"
                class="field is-grouped is-grouped-centered m-t-lg"
              >
                <div class="control">
                  <button
                    class="is-text button"
                    @click.prevent.stop="cancel"
                  >
                    Cancel
                  </button>
                </div>
                <div class="contro">
                  <button
                    :disabled="loading"
                    :class="{ 'is-loading': loading }"
                    class="button is-primary finish-and-certify"
                    @click="update()"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </template>

          <!-- Heper button modals -->
          <more-info
            id="palicense"
            title="PA Lic. # or EPA Firm Certification #"
          >
            <div class="content">
              <p>License number or EPA firm certification number of the individual or company who performed the on-site inspection and dust wipe collection.  Certification must be performed by an EPA-certified Lead Dust Sampling Technician (LDST) or PA-Certified Risk Assessor or Lead Inspector.</p>
              <p>Where to find it: Look on the certificate of Lead Safe or Lead Free Status for the certifying company or individual's license number.  If the certifier provided a copy of their license it will be found there as well.  If you did not receive this information, contact the company or individual who conducted the inspection.</p>
              <p>Example values:</p>
              <p>
                <ul>
                  <li>D-###-##-####</li>
                  <li>PA-#######</li>
                </ul>
              </p>
            </div>
          </more-info>
          <more-info
            id="sampling_date"
            title="Sampling date"
          >
            <div class="content">
              <p>Date on which the samples or XRF analysis were taken by technician or risk assessor at the property unit.  Note: do not use the "date of verification" provided on the lead safe or lead free certificate if those are different.</p>
 
              <p>Where to find: Look on the dust wipe sampling laboratory report or XRF analysis report for sampling dates.   Use the earliest date if there are discrepancies.</p>
            </div>
          </more-info>
          <more-info
            id="lab_name"
            title="Laboratory Name"
          >
            <div class="content">
              <p>Provide the name of the laboratory that processed and analyzed the dust wipe samples.  The laboratory must be accredited by NLLAP.  Note: This should be the name of the laboratory performing the analysis, which is usually not the same firm hired to inspect the property on site.</p>
 
              <p>Where to find:</p>
              <p>Look for the name of the laboratory on the lab report results.  It will most likely include an official header or logo with laboratory name.</p>
              
              <p>Example values:</p>
              <p>
                <ul>
                  <li>Excellent Analytics LLC</li>
                  <li>Delaware Valley Testing</li>
                </ul>
              </p>
            </div>
          </more-info>
          <more-info
            id="acc_number"
            title="Lab Accreditation Number"
          >
            <div class="content">
              <p>Provide the laboratory's identification number provided by the EPA National Lead Laboratory Accreditation Program (NLLAP) or other authorized agency for the accreditation for the lead analysis of paint, soil, and dust matrices.  This is the number that corresponds with the laboratory's accreditation.  If multiple accreditation numbers are listed, provide one that is national vs. regional (such as AIHA-LAP).</p>
 
              <p>Where to find: Look for the accreditation agency logo on the laboratory results report, often found in very fine print near the bottom of the report.  Accreditation agencies include NLLAP, AIHA, LHAP.  The logo may say "Lab ID #" or simply "#" to indicate the number you should enter here.</p>
 
              <p>Example values:</p>
              <p>
                <ul>
                  <li>111986</li>
                  <li>111188</li>
                </ul>
              </p>
            </div>
          </more-info>
          <more-info
            id="insp_type"
            title="Lead Safe and Lead Free Inspections"
          >
            <div class="content">
              <p>Inspections are for either lead safe or lead free certification. </p>
              <p>
                <ul>
                  <li>Lead safe certification involves a technician visually inspecting the property and collecting dust wipe results for laboratory testing.  Remediation of a property to make it lead safe usually involves encapsulation or other temporary techniques that prevent lead paint from entering the home environment.  Lead safe certification lasts for four years and then must be renewed.</li>
                  <li>
                    Lead free certification means that there is no detectable amount of lead paint remaining in the property.  The inspection involves a technician using an XRF machine to test various surfaces on the property in addition to visual inspection.  Remediation of a property to be lead free usually involves complete removal of all lead paint from surfaces using techniques like wet sanding.  Lead free certification lasts forever and does not need to be renewed.
                  </li>
                </ul>
              </p>
              <p>Where to find:</p>
              <p>Look for the certificate provided by the individual or company who performed the on-site inspection.  The top of the certificate should say "Lead Safe" or "Lead Free" Status.</p>
            </div>
          </more-info>
          <more-info
            id="dustwipefigures"
            title="Dust wipe instructions"
          >
            <div class="content">
              <p v-if="isResidential">
                Enter the results of the dust wipe sampling for a control sample, one common area, and <strong>all bedrooms</strong> in the unit.  These results can be found on the laboratory report.  Each sample must test lower than the allowed threshold for lead contamination to obtain certification.  <a @click.prevent="$modal.show('dust-wipe-samples')">Learn more about dust wipe samples</a>.
              </p>
              <p v-else>
                Enter the results of the dust wipe sampling for a control sample and <strong>all common areas</strong>.  These results can be found on the laboratory report.  Each sample must test lower than the allowed threshold for lead contamination to obtain certification. <a @click.prevent="$modal.show('dust-wipe-samples')">Learn more about dust wipe samples</a>.
              </p>
            </div>
          </more-info>
          
          <more-info
            id="dust-wipe-samples"
            title="Dust wipe samples"
          >
            <div class="content">
              <p>Dust wipe testing is required for lead safe certification.  Results are reported in micrograms per square foot (ug/ft2). Please enter the values from the laboratory results report for each required area.  Note: if results are reported using a less than (&gt;20), report the value (20).</p>
              <p><strong>Control sample:</strong> Blank or control samples are new, unused wipes that are sent to the laboratory to determine whether the sampling media are contaminated by providing a “clean” (assumed lead-free) wipe for comparison. The lead dust wipes sampling technician should let the client know which sample is the blank or control sample. If the laboratory detects more than 10 μg/wipe for the blank sample means that an error was made taking the samples new samples must be collected and re-tested.</p>
              <p><strong>Common area:</strong> Rooms such as living room, kitchen, bathroom, dining room, children playrooms, family rooms and other areas property residents share in common are considered common areas.  A floor (F) and window sill (WS) sample is required from at least one common area for rental properties and for all common areas for family daycare facilities.  For rental properties, if your laboratory report includes multiple common area rooms, report the room with the highest values.  For common areas, report results for all common areas.</p>
              <p><strong>Bedrooms:</strong> Floor (F) and window sill (WS) samples are required for each bedroom in the property or property unit.  Add the bedrooms in the order they are listed on the report.  If front/middle/rear is not designated on bedrooms in the report, use "front" by default.</p>
            </div>
          </more-info>

          <!-- More modals -->
          <more-info
            id="rental-instructions"
            title="New unit/inspection instructions"
          >
            <div class="content">
              <p>Use this form to provide the results of the lead safety certification(s) completed on the property.  If the property has multiple residential units, you must submit the results for <strong>each unit</strong> individually, even if they were inspected at the same time.</p>
              <p>Before you start, make sure you have, for this unit:</p>
              <p>
                <ul>
                  <li>The report provided by the technician who performed the inspection(s), including dust wipe results or XRF analysis</li>
                  <li>The certificate of lead free or lead safe status for that unit.  It may be tenant-signed or -unsigned.</li>
                </ul>
              </p>
            </div>
          </more-info>

          <more-info
            id="daycare-instructions"
            title="New unit/inspection instruction"
          >
            <div class="content">
              <p>Please provide the results of the lead safety certification completed on the property.</p>
              <p>Before you start, make sure you have:</p>
              <p>
                <ul>
                  <li>The report provided by the technician who performed the inspection(s), including dust wipe results or XRF analysis</li>
                  <li>The certificate of lead free or lead safe status</li>
                </ul>
              </p>
            </div>
          </more-info>

          <more-info
            id="files"
            title="Where do I get a lead safe or lead free certificate?"
          >
            <div class="content">
              <!-- <h3>Where do I get a lead safe or lead free certificate?</h3> -->
              <p>
                In order to get a lead free or lead safe certificate, a property must be inspected by a certified EPA dust wipe technician or PA risk assessor.  Learn more about inspection requirements and finding a qualified inspector at our list of <a
                  href="https://www.phila.gov/documents/lead-and-healthy-homes-resources-for-landlords/"
                  target="_blank"
                  rel="noopener noreferrer"
                >landlord resources</a>.
              </p>
            </div>
          </more-info>

          <more-info
            id="single-unit"
            title="Single unit property"
            text="Properties with multiple residential units must obtain and report inspection results for each unit.  This number must match the rental license and certificate of occupancy."
          />
        </section>
      </div>
    </div>
  </modal>
</template>

<script>
import tippy from 'tippy.js';
import Checkbox from "@/components/common/Checkbox";
import FixInspectionNotice from '@/components/InspectionForm/FixInspectionNotice';
import Unit from '@/components/InspectionForm/Unit';
import MoreInfo from '@/components/modals/MoreInfo';
import HelpIcon from '@/components/common/HelpIcon';
import { EventBus } from '@/plugins/bus';

import { assign, cloneDeep, isEqual } from 'lodash';

export default {
  name: 'InspectionsForm',
  components: {
    Checkbox,
    FixInspectionNotice,
    Unit,
    MoreInfo,
    HelpIcon,
  },
  data() {
    return {
      initialObject: null,
      cancelGuard: false,
      loading: false,
      inspection: null,
      passedPendingInspections: [],
      assertion: false,
      issues: '',
      error: null,
      loaded: false,
      fixingInspections: false,
      checkboxRules: { required: false },
    };
  },
  computed: {
    details() {
      return this.$store.state.properties.eligibilityCheckDetails;
    },
    // Property Type and Number Of Units, these two values changes this form a lot.
    isResidential() {
      return this.details.propertyType === 'Residential';
    },
    serverInspections() {
      return this.$store.state.properties.inspections.data;
    },
    titlePropertyTypeAndUnits() {
      if (this.$route.name.indexOf('inspections-one') !== -1) {
        return this.$route.params.unit;
      }

      if (this.details.propertyType === 'Residential') {
        if (this.details.numberOfUnits > 1){
          return `${this.details.numberOfUnits} Units`;
        }
        return `1 Unit.`;
      } 
      return `Family daycare.`;
    },
    isNameEditable() {
      return this.details.numberOfUnits > 1;
    },
    leftToSubmit() {
      return this.details.numberOfUnits - this.passedPendingInspections.length;
    },
    streetAddress() {
      return this.$helpers.findDeepProp('selectedProperty.street_address', this.$store.state.properties)  || '';
    },
  },
  watch: {
    serverInspections() {
      if (this.$store.state.properties.eligibilityCheckDetails.id === this.$route.params.uuid) {
        this.initLoadingInspections();
      }
    },
    details() {
      if (this.$store.state.properties.inspections.uuid === this.$route.params.uuid) {
        this.initLoadingInspections();
      }
    },
    inspection: {
      handler(newValue, oldValue) {
        if (oldValue === null) {
          this.initialObject = cloneDeep(newValue);
        }
      },
      cache: false,
      deep: true,
    },
  },
  async beforeMount() {
    try {
      await this.$store.dispatch('properties/getInspections', { uuid: this.$route.params.uuid });
    } catch (err) {
      console.log("Oops", err);
    }
    this.initLoadingInspections();
  },
  mounted() {
    this.$nextTick(() => {
      EventBus.$off('check-unit-names');
      EventBus.$on('check-unit-names', this.checkUnitsNames);

      this.$modal.show('add-inspection-modal');
    });
  },
  methods: {
    isModalOffLocal($event) {
      this.loaded = false;
      this.$router.push({ name: 'submissions-details', params: this.$route.params });
      this.isModalOff($event);
    },
    
    checkUnitsNames() {
      this.$nextTick(() => {
        this.$store.commit('properties/allInspectionsNames', [ this.inspection ]);
      });
    },

    initLoadingInspections() {
      if (!this.details.numberOfUnits || !this.serverInspections) {
        return;
      }

      if (this.loaded) {
        return;
      }
      this.loaded = true;

      // There are not multiple units anymore.
      this.loadSingleUnit();

      this.$nextTick(() => {
        if (this.$refs['finish-and-certify-tooltip']) {
          tippy(this.$refs['finish-and-certify-tooltip'], {
            theme: 'material',
            arrow: true,
            maxWidth: 300,
          });
        }

        if (this.$refs['save-draft-tooltip']) {
          tippy(this.$refs['save-draft-tooltip'], {
            theme: 'material',
            arrow: true,
            maxWidth: 300,
          });
        }
      });
    },

    loadSingleUnit() {
      try {
        console.log("serverInspections", this.serverInspections);
        if (this.$route.name === 'submit-inspections') {
          let numberOfCreatedUnits = this.serverInspections.length;
          if (numberOfCreatedUnits >= this.details.numberOfUnits) {
            throw new Error('You already finished submitting all inspections.');
          }
          
          this.error = false;
          this.inspection = this.emptyUnit(this.details.propertyType);
          return;
        }
        
        const insp = this.serverInspections.find(el => el.name === this.$route.params.unit);
        
        if (/Passed|Pending/gi.test(insp.status)) {
          if (this.isAdmin) {
            // Administrator updading a passing or pending inspection.
            let newInsp = this.emptyUnit(this.details.propertyType, cloneDeep(insp));
            newInsp.orgStatus = insp.status;
            newInsp.originalName = newInsp.name;
            newInsp.fixingInspection = true;
            this.fixingInspections = true;
            this.error = false;
            this.inspection = newInsp;
            return; // I need to kill the function here
          } 
          throw new Error('You should not be modifying already passing or pending inspections.');
        }

        if (insp.status === 'Draft') {
          insp.originalName = insp.name;
          this.error = false;
          this.inspection = this.emptyUnit(this.details.propertyType, cloneDeep(insp));
        } else {
          if (insp.draft) {
            let newInsp = this.emptyUnit(this.details.propertyType, cloneDeep(insp.draft));
            newInsp.orgStatus = insp.status;
            newInsp.originalName = newInsp.name;
            newInsp.fixingInspection = true;
            this.fixingInspections = true;
            this.error = false;
            this.inspection = newInsp;
          } else {
            let newInsp = this.emptyUnit(this.details.propertyType, { name: insp.name });
            newInsp.orgStatus = insp.status;
            newInsp.fixingInspection = true;
            this.fixingInspections = true;
            this.error = false;
            this.inspection = newInsp;
          }
        }
      } catch (err) {
        console.log(err);
        this.error = true;
      }
    },

    async validateUnits(waitUpload) {
      const result = await this.$refs.inspection.isValid(waitUpload);
      console.log(result);
      if (! result ) {
        // this.$warning(this.$wording.certify.error_2);
        if (waitUpload) {
          this.issues = this.$wording.certify.other_erros;
          setTimeout(() => {
            this.issues = '';
          }, 7000);
        }
      }
      return result;
    },

    async checkFailingDustWipeFigures() {
      if (this.inspection.dustWipeFigures.some(dwf => dwf.noPassing === true)) {
        let text = this.$wording.certify.error_threshold_popup;
        if (!this.assertion) {
          text = this.$wording.certify.error_threshold_popup_on_draft;
        }
        return await this.submitGuard(text, {
          title: 'Certification failure',
        });
      }
      
      return true;
    },

    async update() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      // Moving the validation to the top improves user usability since you can cancel the request by non passing dust-wipe figures before submitting everything (including files)
      if (! await this.checkFailingDustWipeFigures()) {
        this.loading = false;
        return;
      }

      if (! await this.validateUnits(true)) {
        this.loading = false;
        return false;
      }

      const submitData = {
        eligibilityCheckUUID: this.details.id,
        inspection: this.inspection,
      };

      // Verify if it is a "LeadFree" inspection, then set the Dust wipe samples to empty
      if (submitData.inspection.inspectionType === 'LeadFree') {
        submitData.inspection.dustWipeFigures = [];
      }

      const resp = await this.$store.dispatch('properties/updateInspection', submitData);
      if (resp) {
        this.$success('Inspection successfully updated');
        this.$modal.hide('add-inspection-modal');
      }
      this.loading = false;
    },

    async submit(needAssertion) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      // Moving the validation to the top improves user usability since you can cancel the request by non passing dust-wipe figures before submitting everything (including files)
      if (! await this.checkFailingDustWipeFigures()) {
        this.loading = false;
        return;
      }

      if (!await this.validateUnits(true)) {
        this.loading = false;
        return false;
      }

      // Administrators won't see the assertion but it is required to calculate inspection status in the backend.
      if (this.isAdmin && needAssertion) {
        this.assertion = true;        
      }

      if (needAssertion && !this.assertion) {
        this.issues = this.$wording.certify.required_assertion;
        setTimeout(() => {
          this.issues = '';
        }, 7000);
        this.loading = false;
        return false;
      }

      if (!needAssertion) {
        this.assertion = false;
      }
      
      let submitData = {};
      if (!!this.inspection.id && this.inspection.status === 'Draft') {
        submitData = {
          ...{
            assertion: this.assertion,
            eligibilityCheckUUID: this.details.id,
            inspectionId: this.inspection.id,
          },
          ...this.inspection,
        };
      } else {
        // This is an update instead of a create
        submitData = {
          assertion: this.assertion,
          eligibilityCheckUUID: this.details.id,
          inspections: [ this.inspection ],
          clearDrafts: false,
        };
      }
      await this.$store.dispatch('properties/submitInspections', submitData);
      this.loading = false;
    },

    async cancel() {
      if (!isEqual(this.initialObject, this.inspection)) {
        if (!await this.submitGuard(this.$wording.submission_details.cancel_guard)) {
          return;
        }
      }
      this.$modal.hide('add-inspection-modal');
    },

    newDustWipeFigures(propertyType) {
      let dustWipeFigures = [
        {
          type: 'control',
          location: '',
          value: null,
          roomNumber: -1,
        },
        // {
        //   type: 'floor',
        //   location: '',
        //   value: null,
        //   roomNumber: 0,
        // },
        // {
        //   type: 'window',
        //   location: '',
        //   value: null,
        //   roomNumber: 0,
        // },
      ];

      if (propertyType === 'Residential') {
        dustWipeFigures.push(
          {
            type: 'floor',
            location: '',
            value: null,
            roomNumber: 0,
          },
          {
            type: 'window',
            location: '',
            value: null,
            roomNumber: 0,
          },
        );
        // dustWipeFigures.push({
        //   type: 'floor',
        //   location: 'front',
        //   value: null,
        //   roomNumber: 1,
        // },
        // {
        //   type: 'window',
        //   location: 'front',
        //   value: null,
        //   roomNumber: 1,
        // });
      }

      return dustWipeFigures;
    },

    // Empty inspection object
    emptyUnit(propertyType, override) {
      const inspection = {
        status: "Draft",
        name: "",
        licenseOrTechnicianNumber: "",
        inspectionDate: "",
        labAccreditationName: "",
        labAccreditationNumber: "",
        inspectionType: "",
        report: null,
        certificates: null,
        update: true,
      };

      let dustWipeFigures = this.newDustWipeFigures(propertyType);

      if (override) {
        if (!(Array.isArray(override.dustWipeFigures) && override.dustWipeFigures.length)) {
          override.dustWipeFigures = dustWipeFigures;
        }
        return assign(inspection, override);
      }
      
      // Empty inspection
      return {
        ...inspection,
        dustWipeFigures,
      };
    },
  },
};
</script>
